import { useIsMobile } from '../../CommonUtils/MediaQueries';
import css from './Tooltip.module.scss';
import Tooltip from '@mui/material/Tooltip';

interface ComponentProps {
    /**
     * Text to display in tooltip
     */
    text: string | JSX.Element;
    /**
     * Will prevent the tooltip from being shown
     */
    disabled?: boolean;
    /**
     * Component to wrap
     */
    children: JSX.Element;
}

export const GMTooltip: React.FC<ComponentProps> = (props) => {
    const isMobile = useIsMobile();

    return (
        props.disabled || isMobile ?
            props.children :
            <Tooltip
                title={props.text}
                followCursor
                disableFocusListener
                key={`tooltip-${props.text}`}
                placement={'right-start'}
                classes={{ tooltip: css.tooltip }}
            >
                {props.children}
            </Tooltip>
    );
};
